import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SEO, SITE_URL, ORG_JSON_LD, BRAND } from "@/lib/seo";

function upsertMeta({ name, property, content }) {
  if (content === undefined || content === null) return;
  const selector = name ? `meta[name="${name}"]` : `meta[property="${property}"]`;
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    if (name) el.setAttribute("name", name);
    else el.setAttribute("property", property);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function upsertJsonLd(id, data) {
  let el = document.head.querySelector(`script[data-seo-id="${id}"]`);
  if (!el) {
    el = document.createElement("script");
    el.setAttribute("type", "application/ld+json");
    el.setAttribute("data-seo-id", id);
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

export default function useSEO(pathOverride) {
  const location = useLocation();
  const path = pathOverride || location.pathname;

  useEffect(() => {
    const meta = SEO[path] || SEO["/"];
    const canonical = `${SITE_URL}${path === "/" ? "" : path}`;

    document.title = meta.title;

    upsertMeta({ name: "description", content: meta.description });
    if (meta.keywords) upsertMeta({ name: "keywords", content: meta.keywords });
    upsertMeta({ name: "robots", content: meta.noindex ? "noindex,nofollow" : "index,follow" });
    upsertMeta({ name: "author", content: BRAND });

    // Open Graph
    upsertMeta({ property: "og:type", content: "website" });
    upsertMeta({ property: "og:site_name", content: BRAND });
    upsertMeta({ property: "og:title", content: meta.title });
    upsertMeta({ property: "og:description", content: meta.description });
    upsertMeta({ property: "og:url", content: canonical });
    upsertMeta({ property: "og:locale", content: "en_IN" });

    // Twitter
    upsertMeta({ name: "twitter:card", content: "summary_large_image" });
    upsertMeta({ name: "twitter:title", content: meta.title });
    upsertMeta({ name: "twitter:description", content: meta.description });

    upsertLink("canonical", canonical);

    upsertJsonLd("org", ORG_JSON_LD);
  }, [path]);
}
